// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { Skeleton, InputLabel, MenuItem, Select, FormHelperText } from '@mui/material';

export default function RHFSelect({ label, states, name, loading = false, ...other }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) =>
        loading ? (
          <Skeleton width={'100%'}>
            <Select />
          </Skeleton>
        ) : (
          <>
            <InputLabel>{label}</InputLabel>
            <Select
              value={field.value}
              label={label}
              onChange={(event) => {
                if (event.target.value !== null) field.onChange(event.target.value);
              }}
              {...other}
            >
              {states.map((state, index) => (
                <MenuItem value={state.value} key={index}>
                  {state.label}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText error={!!error}>{error?.message}</FormHelperText>
          </>
        )
      }
    />
  );
}
